import classNames from 'classnames';
import React, { memo } from 'react';

import styles from './FileIcon.styles.m.css';
import { FileIconType, IDefaultFileIconProps, TFileIconProps } from './FileIcon.types';
import { FileIconChat } from './FileIconChat/FileIconChat';
import { FileIconDefault } from './FileIconDefault/FileIconDefualt';

export * from './FileIcon.types';
export * from './FileIcon.utils';

export const FileIcon = memo<TFileIconProps>((props) => {
  const { progress, onClick, className, onMouseEnter, onMouseLeave } = props;

  return (
    <svg
      style={{ strokeDashoffset: 100 - (progress || 0) / 2.765 }}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className={classNames(styles.icon, className)}
      xmlns="http://www.w3.org/2000/svg"
    >
      {(!props.type || props.type === FileIconType.Default) && (
        <FileIconDefault {...(props as IDefaultFileIconProps)} />
      )}
      {props.type === FileIconType.Chat && <FileIconChat {...props} />}
    </svg>
  );
});
